import { FC, useState, useCallback } from 'react';
import { useFirebase } from '../../providers/FirebaseProvider';
import { Navbar } from '../../components/Navbar';
import { BeatLoader } from 'react-spinners';
import { useAlert } from '../../hooks/useAlert';


export const AuthPage: FC = () => {
    const { signInAsync } = useFirebase();

    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');

    const [isWorking, setIsWorking] = useState<boolean>(false);

    const { showAlert, AlertComponent } = useAlert();

    const handleSignIn = useCallback(async () => {
        if (email && password) {
            setIsWorking(true);

            const result = await signInAsync(email, password);

            if(result.failed) {
                showAlert({ message: result.error!.message, type: 'danger', position: 'bottom-center' });
            } else {
                showAlert({ message: 'Signed in successfully', type: 'success', position: 'top-right' });
            }
        }

        setIsWorking(false);
    }, [email, password, signInAsync]);

    return (
        <div className="min-h-screen flex flex-col bg-gray-100">
            <Navbar/>
            <div className="flex flex-grow items-center justify-center">
                <div className="w-full max-w-md p-8 space-y-8 bg-white bg-opacity-30 backdrop-filter backdrop-blur-lg rounded-lg shadow-md border border-gray-400">
                    <h2 className="text-2xl font-bold text-gray-800 text-center">Sign In</h2>
                    <div className="space-y-4">
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                            <input
                                type="email"
                                id="email"
                                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
                            <input
                                type="password"
                                id="password"
                                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                    </div>
                    <div>
                        {
                        isWorking ? 
                            <BeatLoader/> :
                            <button
                                className="w-full py-2 px-4 bg-indigo-600 text-white font-semibold rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50"
                                onClick={handleSignIn}
                            >
                                Sign In
                            </button>
                        }
                    </div>
                </div>
            </div>

            <AlertComponent/>
        </div>
    );
};